export const eachOf = types => (...args) => {
  for (let i = 0; i < types.length; i++) {
    // HACK we shouldn't do this, but have no option until React 16
    // https://git.hubteam.com/HubSpot/Frontend/issues/390
    const error = types[i](...args);
    if (error != null) {
      return error;
    }
  }
  return null;
};